export { processPlaceholdersFactory, useProcessed, useProcessPlaceholders } from './processPlaceholders';
export type { ProcessPlaceholders, ProcessPlaceholdersFactoryParams } from './processPlaceholders';
